<template>
    <div>        
        <defNavBar title="Ares - Night prices" :actions="hspt.action_items" :home=true @actionClick="updateData" />
        <v-main v-if="this.ready === true">
            <v-container fluid>
                <v-row dense>

                    <v-col :cols="this.showWeekPrices === true ? 8 : 12">
                        <v-card flat>
                            <hsptHeader :hspt="hspt" :weekprices="showWeekPrices" @updateData="getWeekPrijzen" class="mb-2"/>
                            <v-data-table 
                                :items="items"                                 
                                :headers="getHeaders(showWeekPrices)"     
                                :expanded.sync="expanded"
                                :disable-pagination=true
                                :height="wInnerHeight - 125"
                                loading-text="Loading data...please wait"
                                no-data-text="No data to display" 
                                hide-default-footer
                                fixed-header 
                                show-expand
                                dense
                                item-key="hsnp_encrid">
                                <template v-slot:expanded-item="{ item }">   
                                    <tr @click="upd1Hsnp(item.priorityPrice.hsnp_encrid)" style="background-color: rgba(255, 165, 0, 0.3);">
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" ><v-avatar :size="18" style="border: solid 1px rgb(248, 111, 111); margin-right: 5px;"><v-icon color="rgb(248, 111, 111)" small>mdi-parking</v-icon></v-avatar><span>{{ item.priorityPrice.hsnp_datum }}</span></td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.priorityPrice.hsnp_inkoop }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.priorityPrice.hsnp_verkoop }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.priorityPrice.hsnp_margin }} %</td>                                                
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.priorityPrice.hsnp_van }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.priorityPrice.hsnp_tm }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.priorityPrice.hsnp_min_aant_nacht }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.priorityPrice.hsnp_min_inkoop }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.priorityPrice.hsnp_planning }}</td>
                                        <td v-if="screensize === 'xl' || (screensize !== 'xl' && !showWeekPrices)" :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.priorityPrice.hsnp_weekprijs }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.priorityPrice.hsnp_schoonmaak }}</td>
                                        <td v-if="!showWeekPrices" class="small-font">{{ item.priorityPrice.gebr_code }} </td>
                                        <td v-if="!showWeekPrices" class="small-font">{{ item.priorityPrice.hsnp_dt }} </td>    
                                        <td><v-btn icon small @click.stop="deletePriorityPrice(item.priorityPrice.hsnp_encrid)" style="background-color: white;"><v-icon color="red">mdi-close</v-icon></v-btn></td>
                                    </tr>
                                </template>               
                                <template v-slot:item="{ item }">   
                                    <tr @click="upd1Hsnp(item.hsnp_encrid)">
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">
                                            <v-icon v-if="!item.hasPriorityPrice" color="gray" small @click.stop="addPriorityPrice(item.hsnp_encrid)">mdi-plus-circle-outline</v-icon>
                                            <v-icon v-else color="success" small>mdi-arrow-right-bold</v-icon>
                                            <span class="ml-2">{{ item.hsnp_datum }}</span></td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.hsnp_inkoop }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.hsnp_verkoop }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.hsnp_margin }} %</td>                                                
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.hsnp_van }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.hsnp_tm }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.hsnp_min_aant_nacht }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.hsnp_min_inkoop }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.hsnp_planning }}</td>
                                        <td v-if="screensize === 'xl' || (screensize !== 'xl' && !showWeekPrices)" :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''" align="right">{{ item.hsnp_weekprijs }}</td>
                                        <td :class="screensize === 'xl' || showWeekPrices ? 'small-font' : ''">{{ item.hsnp_schoonmaak }}</td>
                                        <td v-if="!showWeekPrices" class="small-font">{{ item.gebr_code }} </td>
                                        <td v-if="!showWeekPrices" class="small-font">{{ item.hsnp_dt }} </td>    
                                        <td></td>
                                    </tr>
                                </template>                                                 
                            </v-data-table>    
                        </v-card>
                    </v-col>

                    <v-col cols="4" v-if="this.showWeekPrices">
                        <v-card flat>

                            <v-card style="height: 30px; display: flex; flex-direction: row; align-items: center;">
                                <span class="px-2">Weekprices</span>
                                <span>
                                    <v-radio-group row dense v-model="weekpricesystem" v-on:change="getWeekPrices" class="mt-4 ml-4">
                                        <v-radio dense key='0' label="Sa-Sa" value='Sa'></v-radio>
                                        <v-radio dense key='1' label="Su-Su" value='Su'></v-radio>
                                    </v-radio-group>
                                </span>
                            </v-card>

                            <v-simple-table fixed-header :height="wInnerHeight - 125" dense class="mt-2">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Week</th>
                                            <th>From</th>
                                            <th>Until</th>
                                            <th style="text-align:right">Purchase</th>
                                            <th style="text-align:right">Sales</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(hsnpw, i) in weekprices.hsnpw" :key="i">
                                            <td class="small-font">{{ hsnpw.week }}</td>
                                            <td class="small-font">{{ hsnpw.fromDate }}</td>
                                            <td class="small-font">{{ hsnpw.untilDate }}</td>
                                            <td class="small-font" align="right">{{ hsnpw.purchaseWeekPrice }}</td>
                                            <td class="small-font" align="right">{{ hsnpw.salesWeekPrice }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>

                </v-row>
            </v-container>
        </v-main>
        <standard_dialog ref="std_dialog" />
        <updSingleHsnp ref="updSingleHsnp" @closeDialog="getHsptNightPrices()"/>
        <excelExportHsnp ref="excelExportHsnp" />
        <excelImportHsnp ref="excelImportHsnp" />
        <rmHsnp ref="rmHsnp" />        
    </div>
</template>

<script>

import updSingleHsnp from "@/views/huis/hspt/hsnp/updSingleHsnp.vue";
import excelExportHsnp from "@/views/huis/hspt/hsnp/excelExportHsnp.vue";
import excelImportHsnp from "@/views/huis/hspt/hsnp/excelImportHsnp.vue";
import rmHsnp from "@/views/huis/hspt/hsnp/rmHsnp.vue";
import defNavBar from '@/components/ui/navbars/navbar.vue';
import hsptHeader from '@/components/huis/hspt/ui/hspt_header_card1.vue';
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
    components: {
        updSingleHsnp,
        excelExportHsnp,
        excelImportHsnp,
        hsptHeader,
        defNavBar,
        rmHsnp,
        standard_dialog,        
    },
    props: ['hspt_encrid'],
    data() {
        return {
            ready: false,
            weekprices: {},
            showWeekPrices: false,
            wInnerHeight: window.innerHeight,
            weekpricesystem: "Sa",
            hspt: {
                action_items: []  /* moet pre defined ivm length check */
            },
            items: [],
            expanded: [],      
        }
    },
    computed: {
        screensize: function () {
            return this.$vuetify.breakpoint.name;
        },
    },
    destroyed() {
        window.removeEventListener('storage', this.storageEventHandler);
        window.removeEventListener("resize", this.resizeEventHandler);
    },
    created() {
        window.addEventListener("resize", this.resizeEventHandler);
        window.addEventListener('storage', this.storageEventHandler)
    },
    mounted() {
        this.getHsptNightPrices();
    },
    methods: {
        showDialog(type, caption, message) {
            this.$refs.std_dialog.open(type, caption, message);
        },
        getHeaders(arg){
            let headers = [
                { text: 'Date', value: 'hsnp_datum', sortable: false},
                { text: 'Purchase', value: 'hsnp_inkoop', align: "end", sortable: false},
                { text: 'Sales', value: 'hsnp_verkoop', align: "end", sortable: false},
                { text: 'Margin', value: 'hsnp_margin', align: "end", sortable: false },
                { text: 'Arrival', value: 'hsnp_van', sortable: false },
                { text: 'Departure', value: 'hsnp_tm', sortable: false },
                { text: 'Min. nights', value: 'hsnp_min_aant_nacht', sortable: false },
                { text: 'Min. purchase', value: 'hsnp_min_inkoop', align: "end", sortable: false  },
                { text: 'Planning', value: 'hsnp_planning', sortable: false },
                { text: 'Week price', value: 'hsnp_weekprijs', align: "end", sortable: false },
                { text: 'Cleaning nights', value: 'hsnp_schoonmaak', sortable: false },
            ]
            if (!arg){
                headers.push({ text: 'User', value: 'gebr_code', sortable: false})
                headers.push({ text: 'Updated', value: 'hsnp_dt', sortable: false})
            }
            headers.push({ text: '', value: 'data-table-expand', sortable: false })
            return headers

        },
        resizeEventHandler() {
            this.wInnerHeight = window.innerHeight;
        },
        deletePriorityPrice(encrid){
            console.log('delete priority price', encrid)
            this.$axios
                .post("ares/json/ares/huis/hspt/hsnp/deletePriorityPrice.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deletePriorityPrice"
                    },
                    deletePriorityPrice: {
                        hsnp_encrid: encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog("error", "Error", res.data.error.message);
                    } else {
                        this.getHsptNightPrices() // reload
                    }
                });            
        },
        addPriorityPrice(encrid){
            console.log('add priority price', encrid)
            this.$refs.updSingleHsnp.open(encrid, true, 'Add');
        },        
        storageEventHandler(e) {
            if(e.key==='reload_hsnp'){
                this.getHsptNightPrices();   
            }
        },
        getWeekPrices(){
            this.$axios
                    .post("ares/json/ares/huis/hspt/hsnp/getHsnpWeekPrices.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHsnpWeekPrices"
                        },
                        getHsnpWeekPrices: {
                            template: this.weekpricesystem,
                            hspt_encrid: this.hspt_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error.message);
                            this.showDialog("error", "Error", res.data.error.message);
                        } else {
                            this.weekprices = res.data.getHsnpWeekPrices;
                            console.log(this.weekprices);
                            this.ready = true;
                        }
                    });
        },
        getWeekPrijzen(data) {
            this.showWeekPrices = data;
            if (this.showWeekPrices === true) {
                this.getWeekPrices();
            }
        },
        getHsptNightPrices() {
            console.log('get prices');
            this.$axios
                .post("ares/json/ares/huis/hspt/hsnp/getHspt2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHspt"
                    },
                    getHspt: {
                        hspt_encrid: this.hspt_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error.message);
                        this.showDialog("error", "Error", res.data.error.message);
                    } else {
                        this.hspt = res.data.getHspt;
                        this.items = res.data.getHspt.hsnp
                        this.expandAll()
                        console.log(this.hspt);
                        this.ready = true;
                    }
                });
        },
        expandAll(){
            this.items.filter(e => e.hasPriorityPrice?this.expanded.push(e):false);
        },            
        upd1Hsnp(hsnp_encrid) {
            this.$refs.updSingleHsnp.open(hsnp_encrid, false, 'Update');
        },
        updateData(data) {
            switch (data) {
                case 'calcWeekprices':
                    window.open(this.$router.resolve({ path: `/huis/hspt/hsnp/calcWeekPrices/${this.hspt_encrid}` }).href, '_blank');
                    break;
                case 'excelExport':
                    this.$refs.excelExportHsnp.open(this.hspt_encrid);
                    break;
                case 'excelImport':
                    this.$refs.excelImportHsnp.open(this.hspt_encrid);
                    break;
                case 'rmHsnp':
                    this.$refs.rmHsnp.open(this.hspt_encrid);
                    break;
                case 'updmHsnp':
                    window.open(this.$router.resolve({ path: `/huis/hspt/hsnp/updmHsnp/${this.hspt_encrid}` }).href, '_blank');
                    break;
                case 'restoreBackup':
                    window.open(this.$router.resolve({ path: `/huis/hspt/restorePriceBackup/${this.hspt_encrid}` }).href, '_blank');
            }
        },
    }
};

</script> 

<style scoped>.small-font {
    font-size: 11px !important;
}</style>
